var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sifa-cont-right"},[_c('div',{staticClass:"personbox"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"sub-page"}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }